import { motion } from 'motion/react';
import React from 'react';

import { Card } from '@shadCN/ui/card';
import { Input } from '@shadCN/ui/input';

interface SignInCardProps {
  isLoading: boolean;
  inputEmail: string;
  setInputEmail: React.Dispatch<React.SetStateAction<string>>;
  inputPassword: string;
  setInputPassword: React.Dispatch<React.SetStateAction<string>>;
  onSubmit: () => void;
}

const SignInCard: React.FC<SignInCardProps> = ({
  isLoading,
  inputEmail,
  setInputEmail,
  inputPassword,
  setInputPassword,
  onSubmit,
}) => {
  const CSSBlock = 'login-card';

  return (
    <motion.div
      initial={{ opacity: 1, scale: 1 }}
      animate={isLoading ? { opacity: 0.4, scale: 0.9 } : {}}
      exit={{ opacity: 1, scale: 1 }}
      transition={{
        duration: 1,
      }}
      key="box">
      <Card className={`${CSSBlock}`}>
        <div className={`${CSSBlock}__brand`}>wingman</div>
        <div className={`${CSSBlock}__title`}>Dashboard</div>
        <Input
          type="email"
          placeholder="Enter your email"
          value={inputEmail}
          onChange={e => setInputEmail(e.target.value)}
          disabled={isLoading}
        />
        <Input
          type="password"
          placeholder="Enter your password"
          value={inputPassword}
          disabled={isLoading}
          onChange={e => setInputPassword(e.target.value)}
          onKeyDown={e => {
            if (e.key === 'Enter') onSubmit();
          }}
        />
      </Card>
    </motion.div>
  );
};

export default SignInCard;
